<template>
  <div>
    <div class="steps-container container">
      <Steps :steps="steps" />
    </div>

    <RouterView />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { RouterView } from 'vue-router';
import Steps from '@/components/simulation/Steps.vue';
import { useSimulation } from '@/composables/useSimulation';

const { product, estimationCompleted, formPluginElement } = useSimulation();

const steps = ref([
  {
    id: 'estimation',
    label: gettext('Estimation'),
    done: false,
  },
  {
    id: 'products',
    label: gettext('Choix du produit'),
    done: false,
  },
  {
    id: 'order',
    label: gettext('Demande d’offre'),
    done: false,
  },
]);

watch(
  () => estimationCompleted.value,
  (value) => {
    // When computed "estimationCompleted" changes, mark step (un)done.
    steps.value[0].done = value;

    if (!value) {
      steps.value[1].done = false;
    }
  }
);

watch(
  () => product.value,
  (value) => {
    // When ref "product" changes, mark step (un)done.
    steps.value[1].done = !!value;
  }
);

onMounted(() => {
  formPluginElement.value = document.querySelector('.simulator-order-form');
  formPluginElement.value.setAttribute('hidden', true);
});
</script>

<style lang="scss" scoped>
.steps-container {
  padding-left: 44px;
  padding-right: 44px;
}
</style>
